import { CheckIcon } from "shared/components/Icons";
import styles from "./Checkbox.module.css";

export const Checkbox = ({ label, ...rest }) => (
  <label className={styles.container}>
    <input className={styles.input} type="checkbox" {...rest} />
    <div className={styles.fakeInput}>
      <CheckIcon />
    </div>
    <span className={styles.label}>{label}</span>
  </label>
);
